module.exports = __webpack_public_path__ + "img/icon-book.39087801.svg";